import { get } from './index.js'

// 获取最新资讯
export const getLatestNews = (params = {}) => {
  return get('/news/listNews', params)
}

// 获取资讯列表
export const getNews = (params = {}) => {
  return get('/news/listNews', params)
}

// 获取资讯国家列表
export const getCountrys = (params = {}) => {
  return get('/news/listCountry', params)
}
// 获取资讯详情
export const getNewsById = (id, locale = '') => {
  const localeParam = locale ? `&locale=${locale}` : ''
  return get(`/news/getNewsById?newsId=${id}${localeParam}`)
}

// 搜索资讯
export const searchNews = (params = {}) => {
  return get('/news/search', params)
}

export default {
  getLatestNews,
  getNews,
  getNewsById,
  searchNews,
} 